<template>
  <input
    class="currency"
    :id="name"
    :name="name"
    ref="inputRef"
    type="text"
    :value="formattedValue"
  />
  <!-- <ul class="errors" v-for="error in errors" :key="error">
    <li>{{ error }}</li>
  </ul> -->
</template>

<script setup lang="ts">
import { watch, onMounted, ref, onBeforeMount, computed, toRef } from "vue";
import { useCurrencyInput, CurrencyInputOptions } from "vue-currency-input";
import { useField } from "vee-validate";
import { Schema, object } from "yup";
import { FormField, FormOption } from "@/types/form";

interface Props {
  name: string;
  field?: FormField;
  options?: CurrencyInputOptions;
  initialValue?: string | number | null;
  modelValue?: string | number | null | object | unknown;
  mode?: "add" | "edit" | "view";
  rules?: Schema;
  disabled: boolean;
}

const props = defineProps<Props>();
const name = toRef(props, "name");

const defaultOptions = ref({
  currency: "USD",
  precision: 2,
  autoDecimalDigits: false,
});

const { formattedValue, numberValue, inputRef, setValue } = useCurrencyInput(
  props.options || defaultOptions.value
);

const { handleChange, value, errors } = useField(
  name.value || "",
  props.rules || object({})
);

onMounted(() => {
  // Currently there is a bug where you have to wait until after mount for useCurrencyInput to properly set the value
  setTimeout(() => {
    // sets the initial value if provided
    if (value.value) {
      setValue(Number(value.value));
    }
  }, 300);
});

watch(numberValue, (newValue, oldValue) => {
  // sync it with vee-validate, this will trigger validation
  handleChange(newValue);
});
</script>

<style lang="css" scoped>
input[type="text"]#currency {
  line-height: 16px;
  height: 33px;
  font-size: 14px;
  border-radius: 0;
  border: 1px solid #ced1d9;
}

ul.errors {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

ul.errors li {
  font-size: 12px;
  color: red;
}
</style>
